export const ACCENT_COLORS = {
  yellow: "#FFD966",
  mint: "#73DCC6",
  coral: "#F58B72",
  purple: "#6554E8",
  ink: "#211A4D",
};

export function resolveAccentColor(color) {
  return ACCENT_COLORS[color] || color || "currentColor";
}
